import { build } from "../../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/smartfuel",
		component: lazy(() => import("./SmartfuelPage")),
	},
]);
